import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import queryString from 'query-string';

// Contexts
import { withTenant, withTranslate } from "../../core/TenantProvider";
// Components - Atoms, Molecules, Organisms, Pages
import LoginContainerStyles from "./styles/KeycloakLoginContainer.style";
import APBackdropLoader from "../../components/atoms/APBackdropLoader";
import ErrorContainer from '../ErrorContainer';
import APHeading from '../../components/atoms/APHeading';
import APLoadingSpinner from '../../components/atoms/APLoadingSpinner';
// Redux
import { ReducerState } from '../../redux/modules';
import { actions as servicesDowntimeAction } from '../../redux/modules/servicesDowntime';
import { actions as keycloakSessionAction } from '../../redux/modules/keycloaksession';


function KeycloakLoginContainer(props: any) {
    const {
        classes,
        authenticateUser,
        isAuthenticated,
        loading,
        translate,
        getServicesErrorObj
    } = props;

    const [error, setError] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    
    const queryParam: queryString.ParsedQuery<string> = queryString.parse(location.search);
    const { token } = queryParam;

    useEffect(() => {
        if (isAuthenticated && loading === 'LOADED') {
            navigate('/account');
        }
    }, [isAuthenticated, loading]);

    useEffect(() => {
        const requestParams = { token };

        authenticateUser(requestParams)
            .then(() => { })
            .catch((error: any) => {
                setError(true);
                getServicesErrorObj(error);
            });
    }, []);

    console.log('document.cookie', document.cookie);

    return (
        !error ?
            <>
                <div className={classes.loginContainer}>
                    <div className={classes.loginContent}>
                        <APHeading className={classes.loginIntroHeader} variant="h4">
                            {translate('octa.login.affiliate.registration.label')}
                        </APHeading>
                    </div>

                </div>
                <APLoadingSpinner />
            </>
            : <ErrorContainer variant='keycloakAuthFail' />
    )
}

const mapStateToProps = (store: ReducerState) => ({
    loading: store.user.loadingState,
    isAuthenticated: store.user.isAuthenticated,
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    getServicesErrorObj: servicesDowntimeAction.getServicesErrorObj,
    authenticateUser: keycloakSessionAction.authenticateUser,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
        withTenant(
            withTranslate(
                withStyles(LoginContainerStyles)(
                    KeycloakLoginContainer
                )
            )
        )
);
